<template>
    <!-- Page Title -->
    <section class="page-title centred" style="background-image: url(/assets/images/background/page-title.jpg);">
        <div class="shape" style="background-image: url(/assets/images/shape/banner-shap.png);"></div>
        <div class="auto-container">
            <div class="content-box">
                <h1>Product Details</h1>
                <ul class="bread-crumb clearfix">
                    <li><router-link to="/">Home</router-link></li>
                    <li>Products</li>
                </ul>
            </div>
        </div>
    </section>
    <!-- End Page Title -->

    <section class="shop-details">
        <div class="auto-container">
            <div class="product-details-content">
                <div class="shape" style="background-image: url(/assets/images/shape/shape-39.png);"></div>
                <div class="row clearfix">
                    <div class="col-lg-6 col-md-12 col-sm-12 image-column">
                        <div class="image-box">
                            <figure class="image"><img :src="product.image_550_550" :alt="product.name"></figure>
                            <div class="preview-link"><a :href="product.image_550_550" class="lightbox-image" data-fancybox="gallery"><i class="far fa-search-plus"></i></a></div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 content-column">
                        <div class="product-details">
                            <h3>{{ product.name }}</h3>
                            <div class="customer-rating clearfix">
                                <ul class="rating pull-left">
                                    <li><i class="fas fa-star"></i></li>
                                    <li><i class="fas fa-star"></i></li>
                                    <li><i class="fas fa-star"></i></li>
                                    <li><i class="fas fa-star"></i></li>
                                    <li><i class="fas fa-star"></i></li>
                                </ul>
                                <div class="review pull-left">
                                    <a href="shop-details.html">( 5 Reviews )</a>
                                </div>
                            </div>                            
                            <div class="text" v-html="product.description">
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>

            <section class="service-section pt-5 pb-5">
                <div class="title-box">
                    <h3 class="text-bold">Chemicals</h3>
                </div>
                <div class="auto-container">                    
                    <div class="three-item-carousel owl-carousel owl-theme owl-dots-none owl-nav-none">
                        <div class="service-block-one">
                            <div class="inner-box">
                                <div class="icon-box"><i class="flaticon-water-bottle-1"></i></div>
                                <h4><a href="#">RO Water Treatment</a></h4>
                                <p>Antiscalant | CIP Chemical: Low pH Organic, High pH</p>
                            </div>
                        </div>
                        <div class="service-block-one">
                            <div class="inner-box">
                                <div class="icon-box"><i class="flaticon-water-bottle-1"></i></div>
                                <h4><a href="#">Boiler Water Treatment</a></h4>
                                <p>Antiscalant | Oxygen Scavenger | pH Booster | Boiler Descaling</p>
                            </div>
                        </div>                        
                        <div class="service-block-one">
                            <div class="inner-box">
                                <div class="icon-box"><i class="flaticon-water-bottle-1"></i></div>
                                <h4><a href="#">ETP Chemicals</a></h4>
                                <p>Coagulations and Flocculations | Organic Removal Media | Active Bio-Culture | Polly Electrolyte | Lime | Ferrous Alum</p>
                            </div>
                        </div>
                        <div class="service-block-one">
                            <div class="inner-box">
                                <div class="icon-box"><i class="flaticon-water-bottle-1"></i></div>
                                <h4><a href="#">Cooling Tower Treatment</a></h4>
                                <p>Antiscalant | Scale Dispersant | pH Reducer | Corrosion Inhibitor |Oxidizing Biocide INon Oxidizing Biocide | Heat Exchange Cleaning</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
           
            <div class="related-product pt-5">
                <div class="title-box">
                    <h3>Related Products</h3>
                </div>
                <div class="row clearfix">
                    <div v-for="(product, index) in related_products" :key="index" class="col-lg-4 col-md-6 col-sm-12 shop-block">
                        <div class="shop-block-one wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500m">
                            <div class="inner-box">
                                <figure class="image-box"><img :src="product.image_280_270" :alt="product.name"></figure>
                                <div class="lower-content">
                                    <div class="shape" style="background-image: url(/assets/images/shape/shape-7.png);"></div>
                                    <h4><router-link :to="`/product-detail/${product.slug}`">{{ product.name }}</router-link></h4>
                                    <p>{{ product.short_description }}</p>
                                    <div class="btn-box">
                                        <router-link :to="`/product-detail/${product.slug}`" class="theme-btn btn-two">Read More</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import { onMounted, watch, ref } from 'vue'
import { useHead } from '@unhead/vue'
import products from '../json/products.json'
import { useRoute } from 'vue-router'

const route = useRoute()
const product = ref(null)
const related_products = ref(null)

watch(
  () => route.fullPath,
  async () => {
    const slug = route.params.slug
    product.value = products.find(product => product.slug === slug)
    related_products.value = products.filter(product => product.slug !== slug)
    window.scrollTo(0, 0)    
  },
  { immediate: true }
)

useHead({
  title: product.value ? product.value.name : 'Product',
  meta: [
    {
      name: 'description',
      content: product.value ? product.value.description : 'Welcome to Akshar.',
    },
  ],
})

onMounted(() => {
    const scriptId = 'script-js-script'

    // Check if the script already exists
    const existingScript = document.getElementById(scriptId)

    if (existingScript) {
    // Replace it: remove and re-add
    existingScript.remove()
    }

    // Create and append a fresh script
    const newScript = document.createElement('script')
    newScript.src = '/assets/js/script.js'
    newScript.id = scriptId
    document.body.appendChild(newScript)

})
</script>
<style scoped>
.service-details-content img{
    width: auto;
}
.figure{
    text-align: center;
}
.shop-section {    
    padding: 100px 0px 150px 0px;
}
.shop-block-one .inner-box{
    padding: 23px 40px 60px 40px;
}
.shop-block{
    margin-bottom: 30px;
}
</style>